// Default timezone to use if browser's timezone cannot be determined
const ZONEDEFAULT = "America/New_York";

// Calculate the current timezone
export function getTimeZone(): string {
    try {
        // Get the browser's timezone using Intl.DateTimeFormat API
        const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // If the browser's timezone is available, return it
        if (browserTZ) {
            return browserTZ;
        }
    } catch (error) {
        // If an error occurs, fall back to the default timezone
    }
    // Return the default timezone if browser's timezone is not available or an error occurs
    return ZONEDEFAULT;
}
